import { render } from "./ServicesMonthFree.vue?vue&type=template&id=4cc12906"
import script from "./ServicesMonthFree.vue?vue&type=script&lang=js"
export * from "./ServicesMonthFree.vue?vue&type=script&lang=js"

import "./ServicesMonthFree.vue?vue&type=style&index=0&id=4cc12906&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__